import { DateTime } from "luxon";

export function formatRecordJoinedLabel(createdAt: unknown): string | null {
  const joined = DateTime.fromISO(String(createdAt));
  if (!joined.isValid) return null;
  return joined.toFormat("MMMM d, yyyy");
}
